import { UpperCasePipe } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { NavigationStart, Router, RouterLink } from '@angular/router';
import { maximumNumberOfCartOrdersDisplayed } from '@layout/core/constants';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutes } from '@shared/helpers';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SidebarModule } from 'primeng/sidebar';
import { Subscription } from 'rxjs';
import { TrapFocusDirective } from '../../../shared/directives/trap-focus.directive';
import { AppNavigationComponent } from '../app-navigation/app-navigation.component';
import { MenuCartOrdersComponent } from '../menu-cart-orders/menu-cart-orders.component';
import { MenuCartOrdersService } from '../menu-cart-orders/menu-cart-orders.service';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        '(window:resize)': 'onScreenResize($event)',
    },
    standalone: true,
    imports: [
        RouterLink,
        ButtonModule,
        BadgeModule,
        SidebarModule,
        TrapFocusDirective,
        AppNavigationComponent,
        UpperCasePipe,
        TranslateModule,
        OverlayPanelModule,
        MenuCartOrdersComponent,
    ],
})
export class MobileMenuComponent implements OnDestroy {
    private readonly subscriptions = new Subscription();

    readonly appRoutes = AppRoutes;
    private routerSubscription!: Subscription;

    isSidebarVisible = false;
    cartOrdersNumber: string = '0';

    constructor(
        private router: Router,
        private menuCartOrdersService: MenuCartOrdersService
    ) {
        this.subscriptions.add(
            this.menuCartOrdersService.menuCartOrders$.subscribe(menuCartOrders => {
                if (menuCartOrders) {
                    this.cartOrdersNumber =
                        menuCartOrders.length > maximumNumberOfCartOrdersDisplayed
                            ? `${maximumNumberOfCartOrdersDisplayed}+`
                            : String(menuCartOrders.length);
                } else {
                    this.cartOrdersNumber = '0';
                }
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    toggleSidebar(): void {
        this.isSidebarVisible = !this.isSidebarVisible;
    }

    onScreenResize(event: any) {
        if (event.target.innerWidth <= 990) {
            this.routerSubscription = this.router.events.subscribe((event: any) => {
                if (event instanceof NavigationStart && this.isSidebarVisible) {
                    this.isSidebarVisible = false;
                }
            });
        }

        if (event.target.innerWidth > 991) {
            this.isSidebarVisible = false;
            this.routerSubscription?.unsubscribe();
        }
    }
}
